export const VISUAL_TEMPLATE_SETTING_KEY = 'visual_template' as const

export const VISUAL_TEMPLATES = ['classic', 'dashboard_blue'] as const

export type VisualTemplate = (typeof VISUAL_TEMPLATES)[number]

export const DEFAULT_VISUAL_TEMPLATE: VisualTemplate = 'classic'

export function isVisualTemplate(value: unknown): value is VisualTemplate {
  return typeof value === 'string' && (VISUAL_TEMPLATES as readonly string[]).includes(value)
}

export function normalizeVisualTemplate(value: unknown): VisualTemplate {
  return isVisualTemplate(value) ? value : DEFAULT_VISUAL_TEMPLATE
}

export function getVisualTemplateLabel(template: VisualTemplate) {
  return template === 'dashboard_blue' ? 'Dashboard Azul' : 'Original'
}
